import axios from "axios";
import store from "@/store/store";
import toast from "@/services/toast";
import urls from "@/services/utilities/urls";
import local_storage_service from "@/services/utilities/local-storage";
import auth from "@/services/auth";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

function getNewAccessToken(originalRequest) {
  return new Promise(function (resolve, reject) {
    // if there is no refresh token, logout from the web-app
    if (!store.state.refresh_token) {
      local_storage_service.clearAndLogout();
    }
    // if there is refresh token, get new access token from refresh token
    var input = {
      refresh_token: store.state.refresh_token,
      // TODO : Remove user id
      id: store.state.user_info.id
    };
    auth
      .getAccessTokenFromRefreshToken(input)
      .then(response => {
        let data = response.data.data;

        let access_token = data.access_token;
        store.dispatch("updateAccessToken", access_token);

        let refresh_token = data.refresh_token;
        store.dispatch("updateRefreshToken", refresh_token);

        let user_info = data.user;
        store.dispatch("updateUserInfo", user_info);

        // process all failed requests that were called while the token was being refreshed
        processQueue(null, access_token);

        // originalRequest.headers["x-auth"] = token;
        originalRequest.headers["Authorization"] = "Bearer " + access_token;

        resolve(axios(originalRequest));
      })
      .catch(error => {
        if (error.response && error.response.status >= 400) {
          console.log('error while refreshing token : ', error.response.data.message)

          // clear localstorage and go to login page
          // as the token and refresh token both are not valid
          local_storage_service.clearAndLogout();
          return;
        }

        processQueue(error, null);
        reject(error);
      })
      .then(() => {
        isRefreshing = false;
      });
  });
}

var init = function (con = {}) {
  const instance = axios.create({
    baseURL: urls.api_url,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });

  instance.interceptors.request.use((config) => {
    store.commit("setLoading", true);
    return config;
  });

  if (Object.keys(con).length) {
    console.log('api config : ', con);
  }

  instance.defaults.headers.common["Authorization"] = "Bearer " + store.state.access_token;

  if(store.state.language_preference != null && store.state.language_preference != 'en'){
    instance.defaults.headers.common["Accept-Language"] = store.state.language_preference;
  }

  // instance.interceptors.response.use(
  //   (res) => {
  //   store.commit('loading/setLoading', false);
  //     return Promise.resolve(res.data);
  //   },
  //   (err) => {
  //   store.commit('loading/setLoading', false);
  //     return Promise.reject(err);
  //   }
  // );
  // Add a response interceptor
  instance.interceptors.response.use(
    function (response) {
      store.commit("setLoading", false);
      return response;
    },
    function (error) {
      if (error.response) {
        const originalRequest = error.config;
        // show error toast if authenticated user is not authorized
        if (403 === error.response.status) {
          toast.error(error.response.data.message);
        }

        // show error toast for failed validation and bad request
        if ([422, 400].includes(error.response.status)) {
          toast.error(error.response.data.message);
        }

        // if access token is invalid, get new access token
        if (401 === error.response.status && !originalRequest._retry) {
          if (isRefreshing) {
            return new Promise(function (resolve, reject) {
                failedQueue.push({
                  resolve,
                  reject
                });
              })
              .then(token => {
                // originalRequest.headers["x-auth"] = token;
                originalRequest.headers["Authorization"] = "Bearer " + token;
                return axios(originalRequest);
              })
              .catch(err => {
                return Promise.reject(err);
              });
          }

          originalRequest._retry = true;
          isRefreshing = true;

          return getNewAccessToken(originalRequest);
        }

        // if 500 error - show error
        if (500 === error.response.status) {
          toast.error(error.response.data.message);
        }
      }

      store.commit("setLoading", false);
      return Promise.reject(error);
    }
  );

  return instance;
};

export default init;
